<template>
  <FieldBox :title="$t('trade.limit-price-label')" class="limit-price">
    <PlusMinusInput
      v-model="limitPrice"
      :step="minTick"
      :min="0"
      :max="999999999"
      :precision="precision"
      :default-value="minTick"
      :match-tick="true"
      :match-precision="true"
    />
    <p v-if="isHK" class="unit-price-tip">
      {{ $t('trade.order-hk-price-hint', [minTick]) }}
    </p>
  </FieldBox>
</template>
<script>
import { mapGetters } from 'vuex'
import PlusMinusInput from 'com/PlusMinusInput'
import getPriceMinTick from 'utils/getPriceMinTick'
import FieldBox from '../FieldBox'
import { MARKET_TYPE } from 'const/stock'
import getPriceAccuracy from 'utils/getPriceAccuracy'

export default {
  name: 'OrderLimitPriceField',
  components: { FieldBox, PlusMinusInput },
  props: {
    minTicks: Array
  },
  computed: {
    ...mapGetters(['tradeRequest']),
    stock() {
      return this.tradeRequest.stock
    },
    order() {
      return this.tradeRequest.order
    },
    orderType() {
      return this.order.orderType
    },
    isHK() {
      return this.stock.market === MARKET_TYPE.HK
    },
    minTick() {
      return getPriceMinTick(this.limitPrice, this.minTicks)
    },
    precision() {
      return getPriceAccuracy(this.minTick)
    },
    limitPrice: {
      get() {
        return this.order.limitPrice
      },
      set(limitPrice) {
        this.$store.dispatch('updateTradeOrder', { limitPrice })
      }
    }
  }
}
</script>
<style lang="less" scoped>
.unit-price-tip {
  font-size: 12px;
  margin-top: 5px;
  text-align: left;
  color: #838d9e;
}
</style>
